import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useAdyen } from '../../../../../../context/Adyen/context.js';
import '../../../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import { useValidateShippingData } from '../utility-hooks/use-validate-shipping-data.js';
import { useTransactionInfo } from './use-transaction-info.js';

var ref;
const getRegularConfig = ({ locale , cartPrices , transactionInfo , currency , country , onAuthorized  }, config)=>{
    var ref3, ref2;
    return {
        buttonLocale: locale,
        buttonType: 'pay',
        buttonSizeMode: 'fill',
        allowedAuthMethods: config === null || config === void 0 ? void 0 : (ref3 = config.googlepay) === null || ref3 === void 0 ? void 0 : ref3.allowedAuthMethods,
        allowedCardNetworks: config === null || config === void 0 ? void 0 : (ref2 = config.googlepay) === null || ref2 === void 0 ? void 0 : ref2.allowedCardNetworks,
        amount: {
            value: (ref = cartPrices === null || cartPrices === void 0 ? void 0 : cartPrices.totalPrice) !== null && ref !== void 0 ? ref : 0,
            currency
        },
        type: 'paywithgoogle',
        countryCode: country,
        transactionInfo,
        onAuthorized: (paymentData)=>{
            onAuthorized && onAuthorized(paymentData);
        },
        isExpress: false
    };
};
var ref1;
const getExpressConfig = ({ locale , cartPrices , transactionInfo , currency , country , onAuthorized , validateShippingData  }, config)=>{
    var ref5, ref4;
    return {
        buttonLocale: locale,
        buttonType: 'checkout',
        buttonSizeMode: 'fill',
        allowedAuthMethods: config === null || config === void 0 ? void 0 : (ref5 = config.googlepay) === null || ref5 === void 0 ? void 0 : ref5.allowedAuthMethods,
        allowedCardNetworks: config === null || config === void 0 ? void 0 : (ref4 = config.googlepay) === null || ref4 === void 0 ? void 0 : ref4.allowedCardNetworks,
        amount: {
            value: (ref1 = cartPrices === null || cartPrices === void 0 ? void 0 : cartPrices.totalPrice) !== null && ref1 !== void 0 ? ref1 : 0,
            currency
        },
        type: 'googlepay',
        countryCode: country,
        transactionInfo,
        isExpress: false,
        emailRequired: true,
        billingAddressRequired: true,
        billingAddressParameters: {
            format: 'FULL',
            phoneNumberRequired: true
        },
        // Step 2: Set the callback intents.
        callbackIntents: [
            'SHIPPING_ADDRESS',
            'PAYMENT_AUTHORIZATION'
        ],
        shippingAddressParameters: {
            allowedCountryCodes: [
                country
            ],
            phoneNumberRequired: true
        },
        // Step 3: Set shipping configurations.
        shippingAddressRequired: true,
        // Shipping method option configurations.
        shippingOptionRequired: false,
        // Step 6: Update the payment data.
        paymentDataCallbacks: {
            onPaymentDataChanged (intermediatePaymentData) {
                return new Promise((resolve)=>{
                    const { callbackTrigger , shippingAddress  } = intermediatePaymentData;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const paymentDataRequestUpdate = {};
                    if (callbackTrigger === 'SHIPPING_ADDRESS' && validateShippingData) {
                        const { isPaymentDataValid , error  } = validateShippingData(shippingAddress);
                        if (!isPaymentDataValid) {
                            paymentDataRequestUpdate.error = error;
                        }
                    }
                    resolve(paymentDataRequestUpdate);
                });
            },
            onPaymentAuthorized (intermediatePaymentData) {
                return new Promise((resolve)=>{
                    const { shippingAddress  } = intermediatePaymentData;
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const paymentDataRequestUpdate = {};
                    if (validateShippingData) {
                        const { isPaymentDataValid , error  } = validateShippingData(shippingAddress);
                        if (!isPaymentDataValid) {
                            paymentDataRequestUpdate.error = error;
                            paymentDataRequestUpdate.transactionState = 'ERROR';
                        }
                    }
                    paymentDataRequestUpdate.transactionState = 'SUCCESS';
                    resolve(paymentDataRequestUpdate);
                });
            }
        },
        // Step 7: Configure the callback to get the shopper's information.
        onAuthorized: (paymentData)=>{
            onAuthorized && onAuthorized(paymentData);
        }
    };
};
const useGooglePayConfig = (props)=>{
    const { config  } = useAdyen();
    const [mapTransactionInfo] = useTransactionInfo();
    const validateShippingData = useValidateShippingData();
    const propsRef = React.useRef(props);
    React.useEffect(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const regularGooglePayConfig = ()=>{
        const { cartPrices , lineItems , currency , country  } = propsRef.current;
        const transactionInfo = mapTransactionInfo({
            cartPrices,
            lineItems,
            currency,
            country
        });
        return getRegularConfig(swcHelpers.objectSpread({}, propsRef.current, {
            transactionInfo
        }), config);
    };
    const expressGooglePayConfig = ()=>{
        const { cartPrices , lineItems , currency , country  } = propsRef.current;
        const transactionInfo = mapTransactionInfo({
            cartPrices,
            lineItems,
            currency,
            country
        });
        return getExpressConfig(swcHelpers.objectSpread({}, propsRef.current, {
            cartPrices: propsRef.current.cartPrices,
            transactionInfo,
            validateShippingData
        }), config);
    };
    return {
        regularGooglePayConfig,
        expressGooglePayConfig
    };
};

export { useGooglePayConfig };
//# sourceMappingURL=use-google-pay-config.js.map
